var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5793 1.58772C23.9471 0.326218 26.0542 0.326227 27.422 1.58776L48.2863 20.8316C49.3862 21.8516 50.0006 23.3031 50.0006 24.7838V44.6409C50.0006 46.0617 49.4362 47.4243 48.4316 48.429C47.4269 49.4336 46.0643 49.998 44.6435 49.998H5.35714C3.93634 49.998 2.57373 49.4336 1.56907 48.429C0.564414 47.4243 0 46.0617 0 44.6409V24.7838C0 23.1617 0.63639 21.8312 1.71432 20.8316L1.7179 20.8282L22.5793 1.58772ZM23.4392 19.3917C22.4529 19.3917 21.6535 20.1912 21.6535 21.1775V22.6247H28.333V21.1775C28.333 20.1912 27.5335 19.3917 26.5473 19.3917H23.4392ZM18.082 21.1775V22.6247H17.428C15.4556 22.6247 13.8566 24.2237 13.8566 26.1961V37.2498C13.8566 39.2222 15.4556 40.8212 17.428 40.8212H32.5632C34.5356 40.8212 36.1346 39.2222 36.1346 37.2498V26.1961C36.1346 24.2237 34.5356 22.6247 32.5632 22.6247H31.9044V21.1775C31.9044 18.2188 29.5059 15.8203 26.5473 15.8203H23.4392C20.4805 15.8203 18.082 18.2188 18.082 21.1775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovt);
export default __webpack_public_path__ + "static/media/govt.cb3e46c7315e3c56f4b1b17a09d1bc8f.svg";
export { ForwardRef as ReactComponent };